<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  mainColor: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
  textFont: {
    type: String,
    default: 'null',
  },
  borderRadius: {
    type: String,
    default: '20px',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  counter: {
    type: Boolean,
    default: false,
  },
  maxLength: {
    type: Number,
    default: 100000,
  },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit('update:modelValue', val);
  },
});
</script>

<template>
  <div class="input">
    <p v-if="$slots.default" class="custom-font">
      <slot></slot>
    </p>
    <q-input
      v-model="model"
      class="core-default-input-form input-form"
      borderless
      :placeholder="placeholder"
      :counter="counter"
      :maxlength="maxLength"
      :disable="disabled"
      autogrow
    />
  </div>
</template>

<style lang="scss">
/* stylelint-disable selector-class-pattern */
.q-field__native {
  color: v-bind(mainColor);
}
/* stylelint-enable selector-class-pattern */
</style>

<style lang="scss" scoped>
@import './inputs';

.input-form {
  border: 1px solid v-bind(mainColor);
  border-radius: v-bind(borderRadius);
  background-color: v-bind(backgroundColor);
}

.custom-font {
  font-family: v-bind(textFont), 'Petit Formal Script', serif;
}
</style>
